import React, { useState } from 'react';

// Tenant logo for the report cover / closing sections. Falls back to the default shield
// when the tenant has no logo configured, or when the image fails to load (e.g. the logo
// object was removed from the bucket) — the report should never show a broken image.
function ReportLogo({ provider, size = 'lg', className = '' }) {
  const [failed, setFailed] = useState(false);
  const src = provider?.logo;

  if (!src || failed) {
    return <div className={`deck-logo ${className}`}>🛡️</div>;
  }

  return (
    <div className={`deck-logo report-logo ${className}`}>
      <img
        src={src}
        alt={provider?.name ? `${provider.name} logo` : 'Company logo'}
        className={`report-logo-img ${size === 'sm' ? 'report-logo-img-sm' : ''}`}
        onError={() => setFailed(true)}
      />
    </div>
  );
}

export default ReportLogo;
